var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBluePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7333 10.2667H16.8667C17.2717 10.2667 17.6 10.595 17.6 11C17.6 11.405 17.2717 11.7333 16.8667 11.7333H11.7333V16.8667C11.7333 17.2717 11.405 17.6 11 17.6C10.595 17.6 10.2667 17.2717 10.2667 16.8667V11.7333H5.13333C4.72832 11.7333 4.4 11.405 4.4 11C4.4 10.595 4.72832 10.2667 5.13333 10.2667H10.2667V5.13333C10.2667 4.72832 10.595 4.4 11 4.4C11.405 4.4 11.7333 4.72832 11.7333 5.13333V10.2667ZM11 0C17.0655 0 22 4.93447 22 11C22 17.0655 17.0655 22 11 22C4.93447 22 0 17.0655 0 11C0 4.93447 4.93447 0 11 0ZM11 1.29412C5.63976 1.29412 1.29412 5.63976 1.29412 11C1.29412 16.3602 5.63976 20.7059 11 20.7059C16.3602 20.7059 20.7059 16.3602 20.7059 11C20.7059 5.63976 16.3602 1.29412 11 1.29412Z",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlus);
export default __webpack_public_path__ + "static/media/BluePlus.1d918af20b691ce5cef28ff5a9396544.svg";
export { ForwardRef as ReactComponent };